import React from 'react';

interface ModelCardProps {
  name: string;
  description: string;
  logo: string;
  tier: 'Free' | 'Paid' | 'Pro' | 'Enterprise' | 'Self-Hosted' | 'Early Access';
  tutorialLink?: string;
  apiKeyLink?: string;
}

const ModelCard: React.FC<ModelCardProps> = ({ name, description, logo, tier, tutorialLink, apiKeyLink }) => {
  const getTierColor = (tier: string) => {
    const colors = {
      'Free': 'bg-green-100 text-green-800',
      'Paid': 'bg-blue-100 text-blue-800',
      'Pro': 'bg-purple-100 text-purple-800',
      'Enterprise': 'bg-gray-100 text-gray-800',
      'Self-Hosted': 'bg-yellow-100 text-yellow-800',
      'Early Access': 'bg-pink-100 text-pink-800'
    };
    return colors[tier as keyof typeof colors] || 'bg-gray-100 text-gray-800';
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow">
      <div className="flex items-center mb-4">
        <img
          src={logo}
          alt={`${name} logo`}
          className="w-8 h-8 object-contain mr-3"
          onError={(e) => {
            (e.target as HTMLImageElement).src = '/provider-icons/default-logo.png';
          }}
        />
        <h3 className="text-lg font-semibold">
          {name === 'MiniMax' ? 'MiniMax' :
           name === 'xAI' ? 'xAI' :
           name === 'Gemini' ? 'Google Gemini' : name}
        </h3>
      </div>
      
      <p className="text-gray-600 text-sm mb-4">{description}</p>
      
      <div className="flex flex-col gap-2">
        <div className="flex items-center justify-between">
          <span className={`px-3 py-0.5 rounded-full text-[0.7rem] sm:text-xs font-medium ${getTierColor(tier)} whitespace-nowrap text-center truncate`}>
            {tier} Tier
          </span>
          
          {tutorialLink && (
            <a
              href={tutorialLink}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-500 hover:text-blue-600 text-sm font-medium flex items-center"
            >
              <span className="flex items-center gap-1">
              <img
                src="/icons/youtube-icon.png"
                alt="YouTube icon"
                className="w-8 h-8 object-contain mr-2"
              />
                Tutorial
              </span>
            </a>
          )}
        </div>
        
        {apiKeyLink && (
          <a
            href={apiKeyLink}
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-gray-600 hover:text-blue-500 break-all"
          >
            Get API Key
          </a>
        )}
      </div>
    </div>
  );
};

export default ModelCard;